// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th[ng-reflect-field=id],
td.id {
  width: 4.5rem;
  text-align: center;
}

td.name {
  padding-left: 0;
  font-weight: 600;
}

th[ng-reflect-field=name],
th[ng-reflect-field=address],
td.name,
td.address {
  width: 25%;
}

:host ::ng-deep .p-treetable-header {
  padding: 0;
  border: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
